module.exports = __webpack_public_path__ + "img/config.fbafe7e0.svg";